/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const FORM_THEME = {
  parts: ["container", "requiredIndicator", "helperText"],
  baseStyle: {
    container: {
      label: {
        color: "brandPrimary.900",
        fontSize: "1rem !important",
        fontWeight: "400",
        lineHeight: "1.3125rem",
      },
    },
  },
};
